import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../../actions';
import API from '../../../apis';

export const getCheckoutReport = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.checkout
        .fetchAllCheckouts(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CHECKOUT_REPORT_FAILED,
              reject: actionTypes.GET_CHECKOUT_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_CHECKOUT_REPORT_LOADING);
  const success = res => action(actionTypes.GET_CHECKOUT_REPORT_SUCCESS, res);

  return request();
};

export const getReservesCheckoutReport = (checkoutWithCafeId, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.checkout
        .fetchReservesCheckoutReportById(checkoutWithCafeId, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_RESERVES_CHECKOUT_REPORT_FAILED,
              reject: actionTypes.GET_RESERVES_CHECKOUT_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_RESERVES_CHECKOUT_REPORT_LOADING);
  const success = res => action(actionTypes.GET_RESERVES_CHECKOUT_REPORT_SUCCESS, res);

  return request();
};

export const postCheckoutReport = data => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.checkout
        .postCheckout(data)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.POST_CHECKOUT_REPORT_FAILED,
              reject: actionTypes.POST_CHECKOUT_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.POST_CHECKOUT_REPORT_LOADING);
  const success = res => action(actionTypes.POST_CHECKOUT_REPORT_SUCCESS, res);

  return request();
};

export const getCheckoutCafe = cafeId => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.checkout
        .fetchCheckoutCafe(cafeId)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CHECKOUT_CAFE_FAILED,
              reject: actionTypes.GET_CHECKOUT_CAFE_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_CHECKOUT_CAFE_LOADING);
  const success = res => action(actionTypes.GET_CHECKOUT_CAFE_SUCCESS, res);

  return request();
};
